// extracted by css-extract-rspack-plugin
export default {"content":"inAppMessageDialog-module__content___d74y9"};